import { useResizeObserver } from '@vueuse/core';
import type { WatchSource } from 'vue';
import ApexCharts, { type ApexOptions } from 'apexcharts';
import type { ChartLabelsModel } from '~/types/apiService';

export function useApexChartUpdater({
  chartId,
  chartContainer,
  chartOptions,
  seriesList,
  labels,
  extraDeps = []
}: {
  chartId: string;
  chartContainer: Ref<HTMLElement | null>;
  chartOptions: ComputedRef<ApexOptions>;
  seriesList: ComputedRef<ApexAxisChartSeries>;
  labels: ComputedRef<ChartLabelsModel>;
  extraDeps?: WatchSource<any>[];
}) {
  const updateChart = () => {
    if (!chartContainer.value) return;
    if (!seriesList.value?.length || !labels.value.categories?.length) return;

    ApexCharts.exec(chartId, 'updateOptions', chartOptions.value, true, true);
    ApexCharts.exec(chartId, 'updateSeries', seriesList.value, true);
    ApexCharts.exec(chartId, 'setLocale', chartOptions.value.chart?.defaultLocale);
  };

  useResizeObserver(chartContainer, () => {
    updateChart();
  });

  onMounted(() => {
    updateChart();
  });

  watch([seriesList, labels, ...extraDeps], updateChart, { immediate: true });
}
